import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Popper from "@material-ui/core/Popper";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";

const allCountries = [
  { name: "Afeganistão", code: "93", iso: "AF", flag: "🇦🇫" },
  { name: "África do Sul", code: "27", iso: "ZA", flag: "🇿🇦" },
  { name: "Albânia", code: "355", iso: "AL", flag: "🇦🇱" },
  { name: "Alemanha", code: "49", iso: "DE", flag: "🇩🇪" },
  { name: "Angola", code: "244", iso: "AO", flag: "🇦🇴" },
  { name: "Arábia Saudita", code: "966", iso: "SA", flag: "🇸🇦" },
  { name: "Argélia", code: "213", iso: "DZ", flag: "🇩🇿" },
  { name: "Argentina", code: "54", iso: "AR", flag: "🇦🇷" },
  { name: "Austrália", code: "61", iso: "AU", flag: "🇦🇺" },
  { name: "Áustria", code: "43", iso: "AT", flag: "🇦🇹" },
  { name: "Azerbaijão", code: "994", iso: "AZ", flag: "🇦🇿" },
  { name: "Bahamas", code: "1242", iso: "BS", flag: "🇧🇸" },
  { name: "Bahrein", code: "973", iso: "BH", flag: "🇧🇭" },
  { name: "Bangladesh", code: "880", iso: "BD", flag: "🇧🇩" },
  { name: "Bélgica", code: "32", iso: "BE", flag: "🇧🇪" },
  { name: "Bolívia", code: "591", iso: "BO", flag: "🇧🇴" },
  { name: "Brasil", code: "55", iso: "BR", flag: "🇧🇷" },
  { name: "Cabo Verde", code: "238", iso: "CV", flag: "🇨🇻" },
  { name: "Canadá", code: "1", iso: "CA", flag: "🇨🇦" },
  { name: "Chile", code: "56", iso: "CL", flag: "🇨🇱" },
  { name: "China", code: "86", iso: "CN", flag: "🇨🇳" },
  { name: "Colômbia", code: "57", iso: "CO", flag: "🇨🇴" },
  { name: "Coreia do Sul", code: "82", iso: "KR", flag: "🇰🇷" },
  { name: "Costa Rica", code: "506", iso: "CR", flag: "🇨🇷" },
  { name: "Cuba", code: "53", iso: "CU", flag: "🇨🇺" },
  { name: "Dinamarca", code: "45", iso: "DK", flag: "🇩🇰" },
  { name: "Egito", code: "20", iso: "EG", flag: "🇪🇬" },
  { name: "El Salvador", code: "503", iso: "SV", flag: "🇸🇻" },
  { name: "Emirados Árabes", code: "971", iso: "AE", flag: "🇦🇪" },
  { name: "Equador", code: "593", iso: "EC", flag: "🇪🇨" },
  { name: "Espanha", code: "34", iso: "ES", flag: "🇪🇸" },
  { name: "Estados Unidos", code: "1", iso: "US", flag: "🇺🇸" },
  { name: "Filipinas", code: "63", iso: "PH", flag: "🇵🇭" },
  { name: "Finlândia", code: "358", iso: "FI", flag: "🇫🇮" },
  { name: "França", code: "33", iso: "FR", flag: "🇫🇷" },
  { name: "Grécia", code: "30", iso: "GR", flag: "🇬🇷" },
  { name: "Guatemala", code: "502", iso: "GT", flag: "🇬🇹" },
  { name: "Guiné-Bissau", code: "245", iso: "GW", flag: "🇬🇼" },
  { name: "Guiné Equatorial", code: "240", iso: "GQ", flag: "🇬🇶" },
  { name: "Haiti", code: "509", iso: "HT", flag: "🇭🇹" },
  { name: "Holanda", code: "31", iso: "NL", flag: "🇳🇱" },
  { name: "Honduras", code: "504", iso: "HN", flag: "🇭🇳" },
  { name: "Hong Kong", code: "852", iso: "HK", flag: "🇭🇰" },
  { name: "Hungria", code: "36", iso: "HU", flag: "🇭🇺" },
  { name: "Índia", code: "91", iso: "IN", flag: "🇮🇳" },
  { name: "Indonésia", code: "62", iso: "ID", flag: "🇮🇩" },
  { name: "Irlanda", code: "353", iso: "IE", flag: "🇮🇪" },
  { name: "Israel", code: "972", iso: "IL", flag: "🇮🇱" },
  { name: "Itália", code: "39", iso: "IT", flag: "🇮🇹" },
  { name: "Jamaica", code: "1876", iso: "JM", flag: "🇯🇲" },
  { name: "Japão", code: "81", iso: "JP", flag: "🇯🇵" },
  { name: "Marrocos", code: "212", iso: "MA", flag: "🇲🇦" },
  { name: "México", code: "52", iso: "MX", flag: "🇲🇽" },
  { name: "Moçambique", code: "258", iso: "MZ", flag: "🇲🇿" },
  { name: "Nigéria", code: "234", iso: "NG", flag: "🇳🇬" },
  { name: "Noruega", code: "47", iso: "NO", flag: "🇳🇴" },
  { name: "Nova Zelândia", code: "64", iso: "NZ", flag: "🇳🇿" },
  { name: "Panamá", code: "507", iso: "PA", flag: "🇵🇦" },
  { name: "Paraguai", code: "595", iso: "PY", flag: "🇵🇾" },
  { name: "Peru", code: "51", iso: "PE", flag: "🇵🇪" },
  { name: "Polônia", code: "48", iso: "PL", flag: "🇵🇱" },
  { name: "Portugal", code: "351", iso: "PT", flag: "🇵🇹" },
  { name: "Reino Unido", code: "44", iso: "GB", flag: "🇬🇧" },
  { name: "República Dominicana", code: "1809", iso: "DO", flag: "🇩🇴" },
  { name: "Romênia", code: "40", iso: "RO", flag: "🇷🇴" },
  { name: "Rússia", code: "7", iso: "RU", flag: "🇷🇺" },
  { name: "São Tomé e Príncipe", code: "239", iso: "ST", flag: "🇸🇹" },
  { name: "Singapura", code: "65", iso: "SG", flag: "🇸🇬" },
  { name: "Suécia", code: "46", iso: "SE", flag: "🇸🇪" },
  { name: "Suíça", code: "41", iso: "CH", flag: "🇨🇭" },
  { name: "Tailândia", code: "66", iso: "TH", flag: "🇹🇭" },
  { name: "Timor-Leste", code: "670", iso: "TL", flag: "🇹🇱" },
  { name: "Turquia", code: "90", iso: "TR", flag: "🇹🇷" },
  { name: "Ucrânia", code: "380", iso: "UA", flag: "🇺🇦" },
  { name: "Uruguai", code: "598", iso: "UY", flag: "🇺🇾" },
  { name: "Venezuela", code: "58", iso: "VE", flag: "🇻🇪" },
  { name: "Vietnã", code: "84", iso: "VN", flag: "🇻🇳" },
];

const useStyles = makeStyles((theme) => ({
  selectorButton: {
    display: "flex",
    alignItems: "center",
    gap: 6,
    padding: "8px 10px",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,0.23)" : "rgba(0,0,0,0.23)"}`,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper,
    cursor: "pointer",
    userSelect: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    minWidth: 110,
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
  },
  selectorButtonOpen: {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
  },
  flagEmoji: {
    fontSize: 20,
    lineHeight: 1,
  },
  codeText: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
  },
  dropdownArrow: {
    fontSize: 20,
    color: theme.palette.text.secondary,
    marginLeft: "auto",
  },

  dropdown: {
    zIndex: 1400,
    width: 320,
  },
  dropdownPaper: {
    borderRadius: 12,
    boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
  },
  searchBox: {
    padding: "10px 14px",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  searchInput: {
    width: "100%",
    fontSize: 14,
    color: theme.palette.text.primary,
    "&::placeholder": {
      color: theme.palette.text.secondary,
      opacity: 1,
    },
  },
  listContainer: {
    maxHeight: 280,
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.divider,
      borderRadius: 3,
    },
  },
  countryItem: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 14px",
    cursor: "pointer",
    transition: "background-color 0.15s",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
  countryItemSelected: {
    backgroundColor: theme.palette.primary.main + "14",
    "&:hover": {
      backgroundColor: theme.palette.primary.main + "22",
    },
  },
  countryFlag: {
    fontSize: 22,
    lineHeight: 1,
    width: 28,
    textAlign: "center",
  },
  countryName: {
    flex: 1,
    fontSize: 14,
    color: theme.palette.text.primary,
    fontWeight: 400,
  },
  countryCode: {
    fontSize: 14,
    color: theme.palette.text.secondary,
    fontWeight: 500,
  },
}));

const CountryCodeSelect = ({ value, onChange }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const anchorRef = useRef(null);
  const searchInputRef = useRef(null);

  const selected = allCountries.find(
    (c) => c.iso === value
  ) || allCountries.find((c) => c.iso === "BR");

  useEffect(() => {
    if (open && searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 100);
    }
    if (!open) {
      setSearch("");
    }
  }, [open]);

  const filtered = allCountries.filter((c) => {
    if (!search) return true;
    const s = search.toLowerCase();
    return (
      c.name.toLowerCase().includes(s) ||
      c.code.includes(s) ||
      c.iso.toLowerCase().includes(s)
    );
  });

  const handleSelect = (country) => {
    onChange(country);
    setOpen(false);
  };

  return (
    <>
      <div
        ref={anchorRef}
        className={`${classes.selectorButton} ${open ? classes.selectorButtonOpen : ""}`}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className={classes.flagEmoji} style={{ display: "flex" }}>
          <img 
            src={`https://flagcdn.com/w20/${selected.iso.toLowerCase()}.png`} 
            alt={selected.name} 
            style={{ width: 20 }} 
          />
        </span>
        <span className={classes.codeText}>+{selected.code}</span>
        <ArrowDropDownIcon className={classes.dropdownArrow} />
      </div>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="bottom-start"
        className={classes.dropdown}
        modifiers={{
          flip: { enabled: true },
          preventOverflow: { enabled: true, boundariesElement: "viewport" },
        }}
      >
        <ClickAwayListener onClickAway={() => setOpen(false)}>
          <Paper className={classes.dropdownPaper}>
            <div className={classes.searchBox}>
              <InputBase
                inputRef={searchInputRef}
                className={classes.searchInput}
                placeholder="Pesquisar país..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                fullWidth
              />
            </div>
            <div className={classes.listContainer}>
              {filtered.length === 0 ? (
                <div style={{ padding: "16px 14px", textAlign: "center", color: "#999", fontSize: 14 }}>
                  Nenhum país encontrado
                </div>
              ) : (
                filtered.map((c) => (
                  <div
                    key={c.iso}
                    className={`${classes.countryItem} ${
                      selected.iso === c.iso ? classes.countryItemSelected : ""
                    }`}
                    onClick={() => handleSelect(c)}
                  >
                    <span className={classes.countryFlag}>
                      <img 
                        src={`https://flagcdn.com/w20/${c.iso.toLowerCase()}.png`} 
                        alt={c.name} 
                        style={{ width: 20, display: "block" }} 
                      />
                    </span>
                    <span className={classes.countryName}>{c.name}</span>
                    <span className={classes.countryCode}>+{c.code}</span>
                  </div>
                ))
              )}
            </div>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </>
  );
};

export default CountryCodeSelect;
